var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: { timeout: -1 },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.text) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "secondary", text: "" },
              on: { click: this.close },
            },
            [_vm._v(" Cerrar ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }